module.exports = __webpack_public_path__ + "static/media/ET062 new.14fbd6fe.jpg";